import { ContentContainer } from './ItemCampaignContainers';

export const renderErrorOrSpinner = (element: JSX.Element) => {
  return <ContentContainer>{element}</ContentContainer>;
};
